const enquiryForm = (() => {
    const initBlock = el => {
        const params = new URLSearchParams(window.location.search);
        const enquiryString = params.get('enquiry');
        
        if (enquiryString) {
            const textArea = el.querySelector('textarea');
            if (textArea) {
                // Replaces hyphens with spaces and capitalizes the first letter for a cleaner look
                const cleanString = enquiryString.replace(/-/g, ' ');
                textArea.value = cleanString.charAt(0) + cleanString.slice(1);
                // Clean the URL bar
                const newUrl = window.location.pathname; // Gets just the path, e.g., /enquiry
                window.history.replaceState({}, document.title, newUrl)
            }
        }
    };
    return { initBlock };
})();

ControlBinders.register(`.enquiry-form`, form => enquiryForm.initBlock(form));